import { CreateTagReq, UpdateTagReq } from '../dto/ReqDtoRepository';
import { SimpleStringResponse, TagListResponse, TagResponse } from '../dto/ResDtoRepository';
import { sendApiRequest, sendDeleteApiRequest, sendGetApiRequest } from './apiConfig';

export const getWorkTagList = async (aui: string): Promise<TagListResponse> => {
  return sendGetApiRequest<TagListResponse>(`/api/v1/work-tag/list?aui=${encodeURIComponent(aui)}`);
};

export const createWorkTag = async (aui: string, data: CreateTagReq): Promise<TagResponse> => {
  return sendApiRequest<TagResponse>('post', `/api/v1/work-tag?aui=${encodeURIComponent(aui)}`, data);
};

export const updateWorkTag = async (aui: string, data: UpdateTagReq): Promise<TagResponse> => {
  return sendApiRequest<TagResponse>('put', `/api/v1/work-tag?aui=${encodeURIComponent(aui)}`, data);
};

export const deleteWorkTag = async (aui: string, tagId: number): Promise<SimpleStringResponse> => {
  return sendDeleteApiRequest<SimpleStringResponse>(
    `/api/v1/work-tag?aui=${encodeURIComponent(aui)}&tagId=${encodeURIComponent(String(tagId))}`
  );
};
